export class Export {
  public entity: string;
  public from;
  public to;

  constructor() {
  }
}
